import { render, staticRenderFns } from "./MessagesPanel.vue?vue&type=template&id=e497e3ec&"
import script from "./MessagesPanel.vue?vue&type=script&lang=js&"
export * from "./MessagesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e497e3ec')) {
      api.createRecord('e497e3ec', component.options)
    } else {
      api.reload('e497e3ec', component.options)
    }
    module.hot.accept("./MessagesPanel.vue?vue&type=template&id=e497e3ec&", function () {
      api.rerender('e497e3ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/components/MessagesPanel.vue"
export default component.exports